/// <amd-module name="Wit/BoardsHub/KanbanBoard/IAnnotationService" />
import { IVssService } from "VSS/Platform/Context";
import { IChecklistItem, IObservableBoardsWorkItem, ITestItem, TestOutcome } from "Wit/BoardsHub/Common/Interfaces";
import { IAnnotationSetting } from "Wit/BoardsHub/Common/KanbanBoardContracts";
import { ExternalLinkedArtifact, ExternalLinkedArtifactIdentifier } from "Wit/Clients/Internal/Contracts/WorkItemTracking";

export interface IAnnotationService extends IVssService {
    addChecklistAnnotation(parent: IObservableBoardsWorkItem, checklistItem: IChecklistItem): void;
    addTestAnnotation(parent: IObservableBoardsWorkItem, testItem: ITestItem): void;
    /**
     * Get item annotation info for the given items.
     */
    getAnnotationsForItemsAsync(itemIds: number[], teamId: string, annotationSettings: IAnnotationSetting[], orderFieldName?: string): Promise<void>;
    getGitHubAnnotationDetails(itemId: number, links: ExternalLinkedArtifactIdentifier[]): Promise<ExternalLinkedArtifact[] | undefined>;
    moveChecklistAnnotation(
        projectId: string,
        teamId: string,
        parentId: number,
        checklistItem: IChecklistItem,
        newIndex?: number,
        previousParentId?: number,
        previousIndex?: number,
        nextIndex?: number,
        onComplete?: () => void
    ): Promise<void>;
    moveTestAnnotation(projectId: string, parentId: number, testItem: ITestItem, newIndex?: number, previousParentId?: number): Promise<void>;
    removeChecklistAnnotation(parent: IObservableBoardsWorkItem, item: IChecklistItem): void;
    removeTestAnnotation(projectId: string, parent: IObservableBoardsWorkItem, item: ITestItem, deleted?: boolean): void;
    /**
     * Handles the user clicking the checkbox on a child item.
     */
    setItemCompletion(parent: IObservableBoardsWorkItem, itemId: number, completed: boolean): Promise<void>;
    setTestOutcome(projectId: string, parent: IObservableBoardsWorkItem, testItem: ITestItem, outcome: TestOutcome): Promise<void>;

    isInCompletedState(type: string, state: string): boolean;
}
